import type {
  TeamOfficeGetResponse,
  TeamOfficeTable,
} from "@bezoned/shared/types/api/team/team-office-get.types.js";

import type { UserPosition } from "./position-resolver.js";

type TeamOfficeMeetingRoom = TeamOfficeGetResponse["meetingRooms"][number];
type ManifestMeetingRoom =
  TeamOfficeGetResponse["preset"]["manifest"]["meetingRooms"][number];

const resolveCurrentTableName = ({
  locationId,
  tables,
}: {
  locationId: string;
  tables: TeamOfficeTable[];
}): string | null =>
  tables.find((table) => table.id === locationId)?.name ?? null;

const resolveCurrentMeetingRoomName = ({
  locationId,
  manifestMeetingRooms,
  meetingRooms,
}: {
  locationId: string;
  manifestMeetingRooms: ManifestMeetingRoom[];
  meetingRooms: TeamOfficeMeetingRoom[];
}): string | null => {
  const meetingRoomIndex = meetingRooms.findIndex(
    (meetingRoom) => meetingRoom.id === locationId
  );

  if (meetingRoomIndex === -1) {
    return null;
  }

  return manifestMeetingRooms.at(meetingRoomIndex)?.defaultName ?? null;
};

export const resolveCurrentLocationName = ({
  manifestMeetingRooms,
  meetingRooms,
  position,
  tables,
}: {
  manifestMeetingRooms: ManifestMeetingRoom[];
  meetingRooms: TeamOfficeMeetingRoom[];
  position: UserPosition;
  tables: TeamOfficeTable[];
}): string | null => {
  if (position.type === "table") {
    return resolveCurrentTableName({
      locationId: position.locationId,
      tables,
    });
  }

  if (position.type === "room") {
    return resolveCurrentMeetingRoomName({
      locationId: position.locationId,
      manifestMeetingRooms,
      meetingRooms,
    });
  }

  return null;
};
